import React from 'react'
import ProgressBarMultiDoc from "./ProgressBarMultiDoc";
import {
    t,
	} from '../../helpers/global'
    
class LinkInputer extends React.Component{
    constructor(props){
        super(props)
    }
    render(){
        const{
            progressVal,
            handleDelete,
            handleOnChangeText,
            value,
            translation
        } = this.props
        return(
    		<div className='link-inputer'>
                <input onChange={handleOnChangeText} value={value} type="text" placeholder='e.g: www.put-link-here.com' />
                <i data-toggle="tooltip" data-placement="top" title={`${t(translation,'DELETE_LANDING_FORM')}`} onClick={handleDelete} className="icon icon-i-del-doc"></i>
            </div>
        )
    }
}

export default LinkInputer